import React, {MouseEvent, useCallback} from "react"
import Modal from "./Modal";
import ModalDialogOption from "./ModalDialogOption";
import styles from '../css/Modal.module.css'
import classNames from "classnames";
import Box from "./Box";
import Text from "./Text";
import {toI18N} from "../utils/I18n";

export interface Props {
    id: string,
    show?: boolean,
    onDismiss?: (event: MouseEvent) => void,
    onConfirm?: (value: MouseEvent) => void,
    message: string,
    description?: string
}

export default (props: Props) => {

    // Props

    const {id, show, description,  message, onDismiss, onConfirm} = props;

    // Callbacks

    const handleOnConfirm = useCallback(
        (e) => {
            onConfirm && onConfirm(e)
        },
        [onConfirm],
    );

    return (
        <Modal contentClassName={styles.textModal} round id={id} show={show} center onDismiss={onDismiss}>
            <Box center className={styles.modalTextArea}>
                <Text size={16}>{message}</Text>
            </Box>
            {description ? <Box className={styles.modalDescriptionArea}>
                <Text center={false} size={12}>{description}</Text>
            </Box> : null}
            <Box center className={styles.modalTextAreaButtonsHolder}>
                <Box center flex className={classNames(styles.modalTextAreaButtonOK)}>
                    <ModalDialogOption onClick={onDismiss} value={toI18N("general_no")}/>
                </Box>
                <Box center flex className={classNames(styles.modalTextAreaButtonOK)}>
                    <ModalDialogOption onClick={handleOnConfirm} value={toI18N('general_yes')}/>
                </Box>
            </Box>
        </Modal>
    )
}

